module.exports = __webpack_public_path__ + "static/img/solution-4.838129e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-4.png
// module id = juIn
// module chunks = 10